enum WorkspaceProjectMetricTypes {
  'Result Metric' = 'Result Metric',
  'Activity Metric' = 'Activity Metric',
  'Resource Metric' = 'Resource Metric',
}

export default WorkspaceProjectMetricTypes
